<div class="add-filters-container">
    <div *ngFor="let filter of additiveFilters" class="add-filter"> 
      <div class="checkbox-name">
        <mat-checkbox [checked]="filter.checked" (change)="onCheck($event, filter.name)" [disabled]="filter.number === 0"></mat-checkbox>
        <span class="filter-name" [title]="filter.name" [ngClass]="getOfferingTypeColorClass(filter.name)">{{ filter.name }}</span>
      </div>
      <span class="filter-number">{{ filter.number }}</span>
    </div>
</div>